import { computed } from 'vue';
import { canHover } from '@/helpers/mediaQueries';

// Unfortunately, floating-vue does not export a config type, even though their docs say you can use `FloatingVueConfig`.
// See: https://github.com/Akryum/floating-vue/discussions/1088
export const tooltipOptionsDefaults = computed(() => ({
  boundary: document.body,
  overflowPadding: 30,
  placement: 'auto',
  distance: 18,
  delay: {
    show: 0,
    hide: 0,
  },
  html: true,
  /*
    Devices with a primary input that does not enable hovering, like touch devices,
    should only trigger tooltips on click.
  */
  ...(canHover.value ? {
    showTriggers: ['hover', 'focus', 'touch'],
    hideTriggers: ['hover', 'focus', 'touch', 'click'],
    autoHide: false,
  } : {
    showTriggers: ['click'],
    hideTriggers: ['click'],
    // Close on click outside (btw: click outside does not prevent the original click)
    autoHide: true,
  }),
  instantMove: true,
  shiftCrossAxis: true,
  computeTransformOrigin: true,
}));

export const tooltipOptionsNoHideOnClick = computed(() => {
  return canHover.value ? {
    showTriggers: ['hover', 'focus'],
    hideTriggers: ['hover', 'focus'],
    autoHide: false,
  } : {
    showTriggers: ['click'],
    hideTriggers: ['click'],
    // Close on click outside (btw: click outside does not prevent the original click)
    autoHide: true,
  };
});
